import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Zap } from 'lucide-react';
import { Button } from './ui/Button';
const EBOOK_COVER = 'https://cdn.magicpatterns.com/uploads/aJ88TpxLAhYpLTzxYVe7bJ/cover_persona_2.png';
export function Hero() {
  return <header className="min-h-screen flex flex-col justify-center items-center relative px-6 py-20 overflow-hidden" data-id="element-123">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0" data-id="element-124">
        <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-[#14b8a6] rounded-full mix-blend-multiply filter blur-[160px] opacity-[0.07] animate-pulse" data-id="element-125" />
        <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] bg-[#06b6d4] rounded-full mix-blend-multiply filter blur-[140px] opacity-[0.04]" data-id="element-126" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#14b8a6] rounded-full filter blur-[200px] opacity-[0.03]" data-id="element-127" />
      </div>

      <div className="max-w-4xl mx-auto z-10 flex flex-col items-center text-center space-y-12" data-id="element-128">
        {/* Text */}
        <div className="space-y-8" data-id="element-129">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/10 bg-white/[0.03] backdrop-blur-sm text-[#14b8a6] text-sm font-medium" data-id="element-130">
            <Zap size={14} fill="currentColor" data-id="element-131" />
            <span className="tracking-wider" data-id="element-132">INGRESOS DIGITALES ATÓMICOS</span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-4xl md:text-6xl lg:text-7xl font-black tracking-tight leading-[1.08] text-white" data-id="element-133">
            No necesitas ser{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#14b8a6] to-[#2dd4bf]" data-id="element-134">
              influencer
            </span>
            .
            <br data-id="element-135" />
            Necesitas un{' '}
            <span className="text-white underline decoration-[#14b8a6] decoration-[3px] underline-offset-[6px]" data-id="element-136">
              sistema
            </span>
            .
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-gray-400 font-light max-w-2xl mx-auto leading-relaxed" data-id="element-137">
            El método simple para monetizar redes sociales sin depender de la
            viralidad.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="pt-4" data-id="element-138">
            <Button size="lg" className="w-full md:w-auto text-xl" data-id="element-139">
              QUIERO EL MÉTODO <ArrowRight className="ml-2" data-id="element-140" />
            </Button>
            <p className="mt-5 text-sm text-gray-500 tracking-wide" data-id="element-141">
              Descarga inmediata • Acceso de por vida
            </p>
          </motion.div>
        </div>

        {/* Floating Ebook */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col items-center justify-center" data-id="element-142">
          <div className="relative" data-id="element-143">
            <img src={EBOOK_COVER} alt="Ebook Ingresos Digitales Atómicos" className="ebook-float w-64 md:w-80 lg:w-96 drop-shadow-[0_25px_50px_rgba(20,184,166,0.12)]" data-id="element-144" />
            <div className="absolute inset-0 -z-10 bg-[#14b8a6] rounded-full blur-[100px] opacity-[0.08] scale-75" data-id="element-145" />
            <div className="ebook-shadow mt-6 mx-auto w-48 md:w-56 h-4 bg-[#14b8a6] rounded-full blur-xl opacity-15" data-id="element-146" />
          </div>
        </motion.div>
      </div>

      {/* Luxury divider */}
      <div className="glow-line w-full max-w-md mx-auto mt-20 mb-4" data-id="element-147" />

      {/* Opening Lead */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="mt-8 max-w-2xl mx-auto glass-card p-8 md:p-10" data-id="element-148">
        <p className="text-lg text-gray-300 leading-relaxed" data-id="element-149">
          <span className="block mb-4 font-bold text-white text-xl" data-id="element-150">
            Estás haciendo "lo correcto" y por eso frustra más.
          </span>
          Publicas. Te esfuerzas. Editas. Buscas ideas. A veces hasta te va
          bien: likes, guardados, comentarios…
          <br data-id="element-151" />
          <br data-id="element-152" />
          Y aun así, cuando cierras la app, la pregunta sigue ahí:
          <br data-id="element-153" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#06b6d4] to-[#14b8a6] font-bold text-xl mt-2 inline-block" data-id="element-154">
            "¿Y el dinero dónde está?"
          </span>
        </p>
      </motion.div>
    </header>;
}